<template>
  <div>
    <transition mode="out-in" name="main">
      <IlluminateQuestion :question="questions[activeQuestionIndex]" @result="applyResult" :key="activeQuestionIndex" />
    </transition>
    <IlluminateProgressBar :active="active" :progress="progress"/>
  </div>
</template>

<script setup lang="ts">
import {computed, inject, onMounted, ref} from "vue";
import IlluminateQuestion from "@/components/Illuminate/IlluminateQuestion.vue";
import IlluminateProgressBar from "@/components/Illuminate/IlluminateProgressBar.vue";
import {recordEvent} from "@/ts/helpers";

const emit = defineEmits(['next']);

const { questions, results, result } = inject('illuminate', { questions: ref([]), results: ref([]), result: ref(-1) } );

const activeQuestionIndex = ref(0);

const applyResult = (answer) => {
  questions.value[activeQuestionIndex.value].answer = answer;

  setTimeout( () => {
    if (activeQuestionIndex.value + 1 < questions.value.length) {
      activeQuestionIndex.value++;
    } else {
      calculateResults();
    }
  }, 1000 );
};

const calculateResults = () => {
  results.value.forEach( r => {
    r.answers = questions.value.filter( (q) => r.indexes.includes(q.answer) ).length;
    console.log( r, r.answers );
  });

  const r = results.value.slice().sort( (a, b) => b.answers - a.answers );

  if( r[0].answers === r[1].answers ) {
    result.value = 2;//Math.trunc( Math.random() * (r.length - 1) + .8 );
    emit('next', result);
    return;
  }

  result.value = r[0].index;

  recordEvent('quiz-end', 5);

  emit('next', result);
};

const active = ref(false);

onMounted( () => {
  setTimeout( () => {
    active.value = true;
  }, 5000);
  active.value = true;
});

const progress = computed( () => {
  const answered = questions.value.reduce( (acc, q) => {
    return acc + (q.answer > -1 ? 1 : 0);
  }, 0);

  return answered / questions.value.length;
});

</script>

<style scoped lang="scss">
.main-enter-active,
.main-leave-active {
  transition: opacity 0.8s ease;
}

.main-enter-from,
.main-leave-to {
  opacity: 0;
}

</style>
